import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="package-button"
export default class extends Controller {
  static targets = [
    "hiddenField",
    "selectionCard",
    "selectionName",
    "selectionTitle",
    "form",
    "packagesCard",
    "selectionButton",
    "packageCard",
    "sidebarItem",
    "sidebarBackground",
  ];

  // SIDEBAR
  connect() {
    this.formTarget.addEventListener("submit", this.validatePackage.bind(this));
    const preselectedId = this.hiddenFieldTarget.value;

    if (preselectedId) {
      const selectedButton = this.element.querySelector(
        `[data-package-id="${preselectedId}"]`,
      );
      if (selectedButton) {
        this.select({ currentTarget: selectedButton }, { scroll: false }); // Avoids scroll when rendering errors to avoid losing focus
      }
    }
    this.updateVisibility();
    document.addEventListener(
      "enrollment-fields:visibility-changed",
      this.updateVisibility.bind(this),
    );
    document.addEventListener(
      "enrollment-fields:active-changed",
      this.setActiveFromEvent.bind(this),
    );
  }

  showCard(event) {
    const newId = Number(event.currentTarget.dataset.packageButtonId);
    this.activeId = newId;
    this.updateVisibility();
  }

  updateVisibility() {
    this.packageCardTargets.forEach((card) => {
      const cardId = Number(card.dataset.packageButtonId);
      const isVisible = card.dataset.enrollmentVisible === "true";

      if (!isVisible) {
        card.classList.add("hidden");
        return;
      }

      card.classList.toggle("hidden", cardId !== this.activeId);
    });

    this.sidebarItemTargets.forEach((item) => {
      const itemId = Number(item.dataset.packageButtonId);
      const isVisible = item.dataset.enrollmentVisible === "true";

      item.classList.toggle("hidden", !isVisible);

      if (itemId === this.activeId) {
        item.classList.add(
          "ring-4",
          "ring-white",
          "ring-opacity-50",
          "scale-105",
        );
      } else {
        item.classList.remove(
          "ring-4",
          "ring-white",
          "ring-opacity-50",
          "scale-105",
        );
      }
    });

    const visibleCount = this.sidebarItemTargets.filter(
      (card) => card.dataset.enrollmentVisible === "true",
    ).length;

    this.sidebarBackgroundTarget.classList.toggle("hidden", visibleCount < 2);
  }

  // PACKAGE SELECTION
  select(event, { scroll = true } = {}) {
    const selectedButton = event.currentTarget;
    const packageId = selectedButton.dataset.packageId;
    const packageName = selectedButton.dataset.packageName;
    const bgClass = selectedButton.dataset.packageBg;
    const titleClass = selectedButton.dataset.packageTitle;
    const buttonClasses = selectedButton.dataset.packageButton;

    this.element.querySelectorAll("[data-package-id]").forEach((btn) => {
      btn.classList.remove("ring-4", "ring-blue-500", "scale-105");
      btn.innerHTML = "Choose Plan";
    });

    selectedButton.classList.add("ring-4", "ring-blue-500", "scale-105");
    selectedButton.innerHTML = `Selected <i class="fa-solid fa-check ml-2"></i>`;

    this.hiddenFieldTarget.value = packageId;
    this.selectionNameTarget.textContent = packageName;

    this.selectionCardTarget.style.backgroundColor = bgClass;

    this.selectionCardTarget.className = `fixed top-0 left-0 w-full shadow-md z-50 transform transition-all duration-500 ease-out opacity-0 -translate-y-full pointer-events-none`;

    this.selectionTitleTarget.className = `${titleClass} flex items-center gap-2 font-semibold text-xl`;

    this.selectionButtonTarget.className = `${buttonClasses} flex items-center justify-center gap-2 transition-all duration-200 cursor-pointer`;

    requestAnimationFrame(() => {
      this.selectionCardTarget.classList.remove(
        "opacity-0",
        "-translate-y-full",
        "pointer-events-none",
      );
      this.selectionCardTarget.classList.add("opacity-100", "translate-y-0");
    });

    if (scroll) {
      this.formTarget.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  validatePackage(event) {
    if (!this.hiddenFieldTarget.value) {
      event.preventDefault();
      alert("Please select a package");
      this.packagesCardTarget.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  setActiveFromEvent(event) {
    const id = Number(event.detail.id);
    this.activeId = id;
    this.updateVisibility();
  }

  deselect() {
    this.hiddenFieldTarget.value = "";

    this.selectionCardTarget.classList.remove("opacity-100", "translate-y-0");
    this.selectionCardTarget.classList.add(
      "opacity-0",
      "-translate-y-full",
      "pointer-events-none",
    );

    this.packagesCardTarget.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    this.element.querySelectorAll("[data-package-id]").forEach((btn) => {
      btn.classList.remove("ring-4", "ring-blue-500", "scale-105");
      btn.innerHTML = "Choose Plan";
    });
  }
}
